import { NgModule } from '@angular/core';
import { SharedModule } from '@biletix/shared/shared.module';
import { VenueService } from './services/venue-service';
import { VenueEventListComponent } from './venue-event-list/venue-event-list.component';
import { VenueRoutingModule } from './venue-routing.module';
import { VenueListItemComponent } from './venue-event-list/Component/venue-list-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { VenueSeatPlanComponent } from './venue-event-list/venue-seat-plan/venue-seat-plan.component';
import { VenueSeatPlanImageModalComponent } from './venue-event-list/venue-seat-plan/venue-seat-plan-image-modal/venue-seat-plan-image-modal.component';
import { VenueParkingModalComponent } from './venue-event-list/venue-parking-modal/venue-parking-modal.component';
import { VenueStay22Component } from './venue-event-list/stay22/stay22.component';

@NgModule({
  declarations: [
    VenueEventListComponent,
    VenueListItemComponent,
    VenueSeatPlanComponent,
    VenueSeatPlanImageModalComponent,
    VenueParkingModalComponent,
    VenueStay22Component
  ],
  imports: [SharedModule, VenueRoutingModule, MatMenuModule],
  providers: [VenueService],
})
export class VenueModule {}
